module.exports = __webpack_public_path__ + "img/bgBox_sp.78322e77.jpg";